/**
 * MAUD ERP Module (Cleaned)
 * Only includes: Assets, Collections, Finance, Leases & Agreements
 */

import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import type { Module } from '../../index';
import MaudErpLayoutWrapper from './MaudErpLayoutWrapper';

// Simple pass-through layout for nested routes
const PassThroughLayout = () => <Outlet />;

// Home Page
const MaudErpHomePage = lazy(() => import('./HomePage'));

// Import routes from each module's config (only 4 required modules)
import { assetManagementRoutes } from './asset-management/routes/config';
import { leasesAgreementsRoutes } from './leases-and-agreements/routes/config';
// Retired with the finance-management route block below — Finance2 is the
// Finance module now. Uncomment both to bring the old screens back.
// import { financeManagementRoutes } from './finance-management/routes/config';
import { finance2Routes } from './finance2/routes/config';
import Finance2RouteBoundary from './finance2/components/Finance2RouteBoundary';
import { collectionsRoutes } from './collections/routes/config';
import employeeManagementRoutes from './employee-management/routes';


const maudErpModule: Module = {
  name: 'maud-erp',
  path: '/app/maud-erp',
  routes: [
    {
      path: '/app/maud-erp',
      element: <MaudErpLayoutWrapper />,
      children: [
        {
          index: true,
          element: <MaudErpHomePage />
        },
        // Asset Management routes
        {
          path: 'asset-management',
          element: <PassThroughLayout />,
          children: assetManagementRoutes
        },
        // Leases and Agreements routes
        {
          path: 'leases-and-agreements',
          element: <PassThroughLayout />,
          children: leasesAgreementsRoutes
        },
        // Finance Management routes — RETIRED. Finance2 is now the Finance
        // module; its menu was renamed to "Finance" and this tree's menu items
        // were deactivated. The code stays because Finance2 reuses this
        // module's master screens (fund, bank, chart of accounts and the rest),
        // which are imported directly by finance2/routes/config.tsx. Restore by
        // uncommenting here and in routes/config.tsx, and reactivating the menu
        // rows (see docs/finance2/README.md).
        // {
        //   path: 'finance-management',
        //   element: <PassThroughLayout />,
        //   children: financeManagementRoutes
        // },
        // Finance2 — now the Finance module
        {
          path: 'finance2',
          element: <Finance2RouteBoundary />,
          children: finance2Routes
        },
        // Collections routes
        {
          path: 'collections',
          element: <PassThroughLayout />,
          children: collectionsRoutes
        },

        {
          path: 'employee-management',
          element: <PassThroughLayout />,
          children: employeeManagementRoutes
        }
      ]
    }
  ]
};

export default maudErpModule;
